import React, { useContext } from "react";
import {
  Badge,
  ButtonGroup,
  Container,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import { CardList, Cart, House, Person } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { DataContext } from "../../Context/DataContext";

const BottomNavigator = () => {
  const location = useLocation();

  const { shopping_cart } = useSelector((state) => state.cart);

  const { categoriesList } = useContext(DataContext);

  return (
    <div className="bottom-navigator">
      <Container>
        <div className="bottom-navigator-item">
          <Link to={"/"} className={location.pathname === "/" ? "active" : ""}>
            <House size={30} />
            <br />
            <span>Home</span>
          </Link>
        </div>
        {/* <div className="bottom-navigator-item">
          <Link
            to={"/catalog"}
            className={
              location.pathname !== "/" &&
              location.pathname !== "/cart" &&
              location.pathname !== "/profile"
                ? "active"
                : ""
            }
          >
            <CardList size={30} />
            <br />
            <span>Categories</span>
          </Link>
        </div> */}

        <div className="bottom-navigator-item">
          <DropdownButton
            as={ButtonGroup}
            key={"up-centered"}
            id={`dropdown-button-drop-up-centered`}
            drop={"up-centered"}
            variant="secondary"
            title={
              <Link
                className={
                  location.pathname !== "/" &&
                  location.pathname !== "/cart" &&
                  location.pathname !== "/profile"
                    ? "active"
                    : ""
                }
              >
                <CardList size={30} />
                <br />
                <span>Categories</span>
              </Link>
            }
          >
            {categoriesList
              .filter((c) => c.top_level)
              .map((category, i) => {
                return (
                  <Dropdown.Item eventKey={i}>
                    <Link to={`/${category?.name ?? ""}/`}>
                      {category?.name ?? ""}
                    </Link>
                  </Dropdown.Item>
                );
              })}
          </DropdownButton>
        </div>

        <div className="bottom-navigator-item">
          <Link
            to={"/cart"}
            className={location.pathname === "/cart" ? "active" : ""}
          >
            <Cart size={30} />
            {(shopping_cart || []).length > 0 && (
              <Badge bg="danger" style={{ position: "absolute" }}>
                {(shopping_cart || []).length}
              </Badge>
            )}
            <br />
            <span>Cart</span>
          </Link>
        </div>

        <div className="bottom-navigator-item">
          <Link className={location.pathname === "/profile" ? "account" : ""}>
            <Person size={30} />
            <br />
            <span>Account</span>
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default BottomNavigator;
